import { P } from "ts-pattern";

export const QueryStatus = {
  Loading: { isLoading: true },
  Idle: { isIdle: true },
  Error: { isLoading: false, error: P.select(P.not(P.nullish)) },
  Resolved: { data: P.select(P.not(P.nullish)) },
  ResolvedAs: <T extends string>(key: T) => ({ data: P.select(key, P.not(P.nullish)) }),
} as const;
